export const getCartBogoConfig = state => state.campaign.cartBogoConfig;
export const getQueryParams = state => state.campaign.query;
export const getDataCampaign = state => state.campaign.dataCampaign;
